/**
 * Runtime config — populated at deploy time by CDK (BucketDeployment injects
 * `js/config.js`). In local dev `scripts/ensure-local-config.js` writes a dev
 * config by shelling out to `aws cloudformation describe-stacks` against
 * HexlandsAdminStack-dev, so the SPA runs against real dev infra.
 *
 * This module is the single source of truth for how to reach Cognito + the
 * admin API. Don't read these values from anywhere else.
 */

export interface AdminConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  userPoolDomain: string; // https://<prefix>.auth.<region>.amazoncognito.com (NO trailing slash)
  userPoolProviderUrl: string; // cognito-idp.<region>.amazonaws.com/<UserPoolId>
  identityPoolId: string;
  adminApiUrl: string; // https://<apiId>.execute-api.<region>.amazonaws.com/<stage>/ (WITH trailing slash)
  samlProviderName: string; // 'IdentityCenter'
  stage: string;
}

declare global {
  interface Window {
    HEXLANDS_ADMIN_CONFIG?: AdminConfig;
  }
}

export function getConfig(): AdminConfig {
  const cfg = window.HEXLANDS_ADMIN_CONFIG;
  if (!cfg) {
    throw new Error(
      'HEXLANDS_ADMIN_CONFIG missing — js/config.js failed to load. ' +
        'In local dev, run `npm run dev` which regenerates config.js from the dev CF outputs.',
    );
  }
  return cfg;
}
